<template>
  <div class="row">
    <div class="col-12">
      <div class="form-group bmd-form-group">
        <label style="word-break: break-all;">
          {{ slip.user.name }}({{ slip.user.username }}) {{ slip.created_at | moment('DD/MM/YYYY HH:mm:ss') }} -
          <a
            :href="slip.file_url"
            target="_blank"
          >{{ slip.file_url }}</a>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slip: {
      type: [Object],
      default() {
        return {};
      }
    }
  }
};
</script>

<style scoped>
</style>